import {
    usePlatformDocument,
    getPlatformDocumentUrl,
    uploadPlatformDocument,
    PLATFORM_DOCUMENTS_BUCKET,
    getFallbackUrl
} from "./usePlatformDocument";

const TERMS_FILE_NAME = "terms.pdf";
const FALLBACK_TERMS_URL = getFallbackUrl(TERMS_FILE_NAME);

/**
 * Hook to fetch the Terms & Conditions PDF URL from Supabase storage.
 * Falls back to the static file if no uploaded version exists.
 */
export const useTermsAndConditions = () => {
    return usePlatformDocument(TERMS_FILE_NAME);
};

/**
 * Utility function to get the T&C URL synchronously (for non-component use).
 * This returns the fallback URL immediately and the actual URL via callback.
 */
export const getTermsUrl = async (): Promise<string> => {
    return getPlatformDocumentUrl(TERMS_FILE_NAME);
};

/**
 * Upload a new Terms & Conditions PDF (admin only)
 */
export const uploadTermsPdf = async (
    file: File,
): Promise<{ success: boolean; error?: string }> => {
    return uploadPlatformDocument(file, TERMS_FILE_NAME);
};

export { FALLBACK_TERMS_URL, PLATFORM_DOCUMENTS_BUCKET, TERMS_FILE_NAME };
